import React from "react"
import { useState, useEffect } from "react"
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  FormControl,
  IconButton,
  Stack,
  Autocomplete,
  TextField,
  Popover,
  Checkbox,
  Pagination,
  Dialog,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  Paper,
  TableCell,
  TableBody,
  DialogTitle,
  Tooltip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import "react-datepicker/dist/react-datepicker.css"
import {
  ApiGetOrphanAllocations,
  ApiGetVenueList,
  ApiGetNearbyShopper,
  ApiGetClientEntityByClientGroupId,
  ApiGetShopperPopUpDetails,
  ApiChangeOrphanAllocationsDate,
  ApiGetShopperList,
  ApiGetVisitTimes,
  ApiBulkAssignShopper,
  ApiPutCancelJob,
  ApiPostInviteShopper,
  ApiGetCancelledShopper,
  ApiGetAllocationCriteriaDetails,
  ApiImportBulkAssignShopper,
  ApiUpdateVenueNotes,
  ApiCreateVenueNotes,
  ApiDeleteVenueNotes,
  ApiGetAppliedAllocations,
  ApiGetApproveAllocationShopper,
  ApiGetAllocationWarning,
  ApiPostUpdateAppliedAllocationStatus,
  ApiRejectAppliedAllocation,
  ApiHoldAppliedAllocation,
  ApiGetNewAppliedBundleAllocation,
  ApiGetAppliedBundleAllocations,
  ApiHoldBundleAppliedAllocation,
  ApiRejectBundleAllocation,
  ApiPostUpdateBundleAppliedAllocationStatus,
  ApiApproveShopperBundle,
  ApiGetNewBrief,
} from "../../../apiService/Core/Apicall.tsx"
import useDebounce from "../CreateAllocations/UseDebounce.tsx"
import Dcrage from "./Dcrage.tsx"
import dayjs, { Dayjs } from "dayjs"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import type { RootState } from "../../../global/config/store.ts"
import { toast } from "react-toastify"
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts"
import { useShopperDetails } from "../../../global/ShopperDetailsUtils.ts"
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { CancelOutlined, Close, DeleteOutlined, DescriptionOutlined, Edit, EditOutlined, Error, FileUploadOutlined, InsertDriveFileOutlined, PictureAsPdfOutlined, Warning } from "@mui/icons-material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { endOfMonth, startOfMonth } from "date-fns"
import { setDate } from "../../../global/config/Reducer/dateSlice.ts"
import { setCurrentPageData } from "../../../global/config/Reducer/orphanPaginationSlice.ts"
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import ReadBrief from "../NewBrif/ReadBrief.tsx"

dayjs.extend(utc);
dayjs.extend(timezone);

const stateOptions = [
  { label: "Victoria", value: "VIC" },
  { label: "Western Australia", value: "WA" },
  { label: "South Australia", value: "SA" },
  { label: "Queensland", value: "QLD" },
  { label: "Australian Capital Territory", value: "ACT" },
  { label: "New South Wales", value: "NSW" },
  { label: "Tasmania", value: "TAS" },
  { label: "Northern Territory", value: "NT" },
];

export default function OrphanAllocation() {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const dispatch = useDispatch()
  const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
  const selectedPaginationRedux = useSelector((state: RootState) => state.orphanPagination.currentPage)
  const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
  const [allocations, setAllocations] = useState<any>([])
  const [venueName, setVenueName] = useState([])
  const [venueNameValue, setVenueNameValue] = useState<any>("")
  const [clientEntityList, setClientEntityList] = useState<any>([])
  const [tempclientEntityList, setTempClientEntityList] = useState<any>([])
  const [clientEntityId, setClientEntityId] = useState<any>(null)
  const [tempclientEntityId, setTempClientEntityId] = useState<any>(null)
  const debouncedClientEntityId = useDebounce(clientEntityId, 500)
  const debouncedVenue = useDebounce(venueNameValue, 700)
  const [nearestOpen, setOpenNearest] = useState(false)
  const [openCriteria, setOpenCriteria] = useState(false)
  const [jobCriteria, setJobCriteria] = useState<any>([])
  const [selectedAllocationFC, setselectedAllocationFC] = useState<any>([])
  const [nearbyShopper, setNearbyShopper] = useState<any>([])
  // const [loanData, setLoanData] = useState()
  const [searchText, setSearchText] = useState("");
  // Updated pagination state
  const [currentPage, setCurrentPage] = useState(selectedPaginationRedux)
  const [totalCount, setTotalCount] = useState(0)
  const itemsPerPage = 10

  const Clientlist = useSelector((state: RootState) => state.client.clientList)
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
  const [tempselectedClient, setTempSelectedClient] = useState<any>()
  const [ClientId, setClientId] = useState(null)

  const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
  const [selectedAllocations, setSelectedAllocations] = useState<string[]>([]); // store selected allocation IDs
  const [selectAll, setSelectAll] = useState(false);
  const [showdateselect, setshowdateselect] = useState(false);
  const [selectedNewDate, setSelectedNewDate] = useState<Dayjs | null>();
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>();
  const [shopperlist, setshopperlist] = useState([]);
  const [selectedShopper, setSelectedShopper] = useState<any>();
  const [searchShopper, setsearchShopper] = useState<any>([]);
  const [visitTimes, setVisitTimes] = useState<any[]>([]);
  const [visitTimesValues, setVisitTimesValues] = useState<any[]>([]);
  const [state, setState] = useState<any>("");
  const [selectedNearbyShoppers, setSelectedNearbyShoppers] = useState<{ [key: string]: number[] }>({});
  const [currentAllocationId, setCurrentAllocationId] = useState<number | null>(null);
  const [cancelledShopper, setCancelledShopper] = useState<any>([]);
  const [openCancelledDialog, setOpenCancelledDialog] = useState(false);
  const [openBulkImport, setOpenBulkImport] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const [siteNote, setSiteNote] = useState<string>("")
  const [selectedNoteId, setSelectedNoteId] = useState<number | null>(null)
  const [openAddNote, setOpenAddNote] = useState<boolean>(false)
  const [appliedAllocation, setAppliedAllocation] = useState<any>([])
  const [shoppers, setShoppers] = useState<any>([])
  const [allocationCriteria, setAllocationCriteria] = useState<any>()
  const [openApplication, setOpenApplications] = useState<boolean>(false)
  const [editedDates, setEditedDates] = useState<{ [key: number]: any }>({});
  const [selectedVisitTimeIds, setSelectedVisitTimeIds] = useState<{ [key: number]: number | null }>({});
  const [skipTrainingStatus, setSkipTrainingStatus] = useState<{ [key: number]: boolean }>({});
  const [issueList, setIssueList] = useState<any>([])
  const [openIssueDialog, setOpenIssueDialog] = useState(false)
  const [OpenHoldReason, setOpenHoldReason] = useState<boolean>(false)
  const [holdId, setholdId] = useState<number | string>()
  const [reasonforhold, setreasonforhold] = useState<any>()
  const [isActive, setIsActive] = useState(false);
  const [isActive1, setIsActive1] = useState(false);
  const [groupappliedAllocation, setgroupAppliedAllocation] = useState<any>([])
  const [ShopperDetailsForTransBundle, setShopperDetailsForTransBundle] = useState<any>([])
  const [appliedData, setAppliedData] = useState<any[]>([]);
  const [bundleId, setBundlleId] = useState<any>();
  const [ShopperDetailsfornormalbundle, setShopperDetailsfornormalbundle] = useState<any>([])
  const [sendBundleData, setSendBundleData] = useState<any>(null)
  const [brief, setBrief] = useState<any>()






  useEffect(() => {
    if (Clientlist.length > 2) {
      // setSelectedClient(Clientlist[2])
      setClientId(Clientlist[2].clientGroupName)
    }
  }, [Clientlist])

  // Updated pagination handler to call API with new page
  const handlePageChange = (event: any, value: any) => {
    setCurrentPage(value)
    dispatch(setCurrentPageData(value))
    const jobMonth = currentDate.getMonth() + 1
    const jobYear = currentDate.getFullYear()
    ApiCallGetAllocations(jobMonth, jobYear, value)
    setOpenNearest(false);
  }

  const handlePrevMonth = () => {
    setCurrentPage(1)
    dispatch(setCurrentPageData(1))
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
      const jobMonth = newDate.getMonth() + 1
      const jobYear = newDate.getFullYear()
      // currentPage === 1 && ApiCallGetAllocations(jobMonth, jobYear, currentPage) // Reset to page 1 when month changes
      dispatch(setDate(newDate))
      return newDate
    })
  }

  const handleNextMonth = () => {
    setCurrentPage(1)
    dispatch(setCurrentPageData(1))
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
      const jobMonth = newDate.getMonth() + 1
      const jobYear = newDate.getFullYear()
      // currentPage === 1 && ApiCallGetAllocations(jobMonth, jobYear, currentPage) // Reset to page 1 when month changes
      dispatch(setDate(newDate))
      return newDate
    })
  }

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = new Date(event.target.value + "-01")
    // setCurrentDate(newDate)
    dispatch(setDate(new Date(event.target.value)))
    setCurrentPage(1)
    dispatch(setCurrentPageData(1))

    // Call API with the new date
    const jobMonth = newDate.getMonth() + 1
    const jobYear = newDate.getFullYear()
    // currentPage === 1 && ApiCallGetAllocations(jobMonth, jobYear, currentPage) // Reset to page 1 when date changes
  }

  const formatDate = (date: Date) => {
    return `${date?.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
  }

  const fetchData = async () => {
    // const currentDate = new Date()
    const jobMonth = currentDate.getMonth() + 1
    const jobYear = currentDate.getFullYear()
    await ApiCallGetAllocations(jobMonth, jobYear, currentPage) // Start with page 1
    //await ApiCallGetVenueList()
    await handleGetClientList()
  }
  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(timeout);
    clearSelections();
  }, [debouncedVenue, clientEntityId, state])

  useEffect(() => {
    selectedClientName && setSelectedClient(selectedClientName)
  }, [selectedClientName])


  // Updated useEffect to handle client changes
  // useEffect(() => {
  //   if (selectedClient) {
  //     const jobMonth = currentDate.getMonth() + 1
  //     const jobYear = currentDate.getFullYear()
  //     clientEntityId && ApiCallGetAllocations(jobMonth, jobYear, 1) // Reset to page 1 when client changes
  //     setCurrentPage(1)
  //   }
  // }, [clientEntityId])

  const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
    let data = `?offset=0&limit=500`
    if (clientEntityId) {
      data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
    } else if (selectedClient?.clientGroupName) {
      data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
    }
    const res = await ApiGetVenueList(data)
    const response = res?.data.map((item: any) => ({
      label: item.venueName,
      value: item.venueId,
      state: item.state,
      entityTypeName: item.entityTypeName
    }))
    setVenueName(response)
  }

  useEffect(() => {
    if (debouncedClientEntityId || selectedClient?.clientGroupName) {
      ApiCallGetVenueList(debouncedClientEntityId)
    } else {
      setVenueName([]) // Clear venue list when business is cleared
      setVenueNameValue(null) // Also clear selected venue
    }
  }, [debouncedClientEntityId, selectedClient?.clientGroupName])

  useEffect(() => {
    if (searchText) {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      ApiCallGetAllocations(jobMonth, jobYear, currentPage)
    }
  }, [searchText])

  useEffect(() => {
    if (selectedClient?.clientGroupName) {
      handleGetClientList()
    }
  }, [selectedClient?.clientGroupName])

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
    if (!selectedClient?.clientGroupName) return
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data)
      console.log(res.data)
      setClientEntityList(res.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }
  const handleGetClientList2 = async () => {
    const data = `?ClientGroupName=${tempselectedClient?.clientGroupName}`
    if (!tempselectedClient?.clientGroupName) return
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data)
      console.log(res.data)
      setTempClientEntityList(res.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }
  useEffect(() => {
    if (tempselectedClient) {
      handleGetClientList2()
    }
  }, [tempselectedClient])
  useEffect(() => {
    if (selectedClient && currentDate) {
      const timeout = setTimeout(() => {
        ApiCallGetAllocations(currentDate.getMonth() + 1, currentDate.getFullYear(), currentPage)
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [currentDate, selectedClient])

  // Updated ApiCallGetAllocations with proper pagination
  const ApiCallGetAllocations = async (jobMonth: any = "", jobYear: any = "", page: number = currentPage) => {
    if (selectedClient) {
      setAllocations([])
      // const offset = (page - 1) * itemsPerPage
      const offset = Math.max(0, (page - 1) * itemsPerPage);
      let data = `?offset=${offset}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}&limit=${itemsPerPage}&jobMonth=${jobMonth}&jobYear=${jobYear}${selectedClient?.clientGroupName ? `&allocationClientGroup=${selectedClient.clientGroupName}` : ""}${state ? `&state=${state}` : ""}`

      if (venueNameValue) data += `&venueId=${venueNameValue}`
      if (searchText) data += `&searchTerm=${searchText}`

      try {
        const res: any = await ApiGetOrphanAllocations(data)
        setAllocations(res?.data || [])

        // Set total count from API response for pagination
        if (res?.totalDataCount !== undefined) {
          setTotalCount(res.totalDataCount)
          // setSelectAll(false)
          // setSelectedAllocations([])
        }

      } catch (error) {
        console.error("Error during API call:", error)
        toast.error("Failed to load allocations")
      }
    }
  }

  const navigate = useNavigate()
  const handelInvite = (stateData: any) => {
    sessionStorage.setItem("inviteShopperState", JSON.stringify(stateData))
    const url = `/admin/allocations/Invite-Shopper`
    window.open(url, "_blank")
  }

  const handleAssign = (stateData: any) => {

    if (stateData?.bundleId?.bundleId || stateData?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId) {
      window.alert("This task is part of a bundle and cannot be assigned individually.");
      return;
    }
    const noonDate = new Date(currentDate);
    noonDate.setHours(12, 0, 0, 0);
    const stateWithDate = {
      ...stateData,
      selectedDate: noonDate.toISOString()
    };
    sessionStorage.setItem("inviteShopperState", JSON.stringify(stateWithDate))
    const url = `/admin/allocations/assign-Shopper`
    window.open(url, "_blank")
  }


  const ApiCallGetNearbyShopper = async (newVenueId: any, allocationId: any) => {
    const data = `?venueId=${newVenueId}&allocationId=${allocationId}`
    setNearbyShopper([])
    // &kilometerRange=10
    try {
      const res: any = await ApiGetNearbyShopper(data)
      setNearbyShopper(res?.data)
    } catch (error) {
      const message =
        error?.response?.data?.message || // API error message
        error?.message ||                 // JS error message
        String(error);
      toast.error(message)
      console.log("Error", error)
    }
  }
  const ApiCallGetCriteria = async (allocationId: any, clientEntityId: number) => {
    const data = `?allocationId=${allocationId}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}`
    setJobCriteria([])
    // &kilometerRange=10
    try {
      const res: any = await ApiGetAllocationCriteriaDetails(data)
      if (res?.data) {
        setOpenCriteria(true)
        setJobCriteria(res?.data)
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message || // API error message
        error?.message ||                 // JS error message
        String(error);
      toast.error(message)
      console.log("Error", error)
    }
  }

  const getBrief = async (venueId: string, clientEntity: string) => {
    try {
      const data = `?venueId=${venueId}&clientEntityId=${clientEntity}`
      const res = await ApiGetNewBrief(data)
      if (res?.status || res?.success) {
        setBrief(res)
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong")
    }
  }

  console.log(nearbyShopper)

  const handleSelectCard = (id: string) => {
    if (selectedAllocations.includes(id)) {
      setSelectedAllocations(selectedAllocations.filter((item) => item !== id));
    } else {
      setSelectedAllocations([...selectedAllocations, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      // setSelectedAllocations([]); // clear all
      const currentPageIds = allocations.map((a: any) => a?.allocationId);
      setSelectedAllocations(prev => prev.filter(id => !currentPageIds.includes(id)));
    } else {
      // setSelectedAllocations(allocations.map((a: any) => a?.allocationId)); // select all allocation IDs
      const currentPageIds = allocations.map((a: any) => a?.allocationId);
      setSelectedAllocations(prev => [...new Set([...prev, ...currentPageIds])]);
    }
    setSelectAll(!selectAll);
  };

  const handleUpateDetails = async () => {
    // setshowdateselect(true)
    try {
      const data = {
        allocationIds: selectedAllocations,
        monthToMove: dayjs(selectedNewDate).month() + 1,
        yearToMove: dayjs(selectedNewDate).year()
      }
      const res = await ApiChangeOrphanAllocationsDate(data)
      if (res) {
        toast.success("Allocatios moved successfully")
      }
      setshowdateselect(false)
      ApiCallGetAllocations(currentDate.getMonth() + 1, currentDate.getFullYear(), currentPage)
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  }
  const getShopperList = async (text: any) => {
    setshopperlist([])
    try {
      const data = `?offset=0&limit=1000${text?.length > 0 ? `&search=${text}` : ''}`
      const res = await ApiGetShopperList(data)
      const originonal = res.data
      setshopperlist(originonal)
    } catch (error) {
      alert(error)
    }
  }
  useEffect(() => {
    getShopperList(searchShopper);
  }, [searchShopper])
  const handleGetVisitTimeList = async () => {
    try {
      const response: any = await ApiGetVisitTimes();
      setVisitTimes(response.data);
      console.log("visit times list", response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  useEffect(() => {
    handleGetVisitTimeList()
  }, [])


  const handleBulkAssign = async (date: any, shopper: any, times: any) => {
    if (!date || !shopper || !times) {
      toast.error("All Fields are required")
      return;
    }
    try {
      if (selectedAllocations.length === 0) {
        toast.error("Please select at least one allocation");
        return;
      }
      console.log("Date")
      const dateTopass = dayjs(date).format("YYYY-MM-DD")
      const data = {
        allocations: selectedAllocations,
        selectedVisitDate: dateTopass,
        selectedVisitTime: times.join(","),
        userId: shopper?.userId
      }
      const response = await ApiBulkAssignShopper(data);
      toast.success(response.message)
      setOpen(false)
      setSelectedAllocations([]);
      setSelectAll(false);
      setVisitTimesValues([]);
      setSelectedShopper(null)
      setSelectedDate(new Date());
      const jobMonth = currentDate.getMonth() + 1;
      const jobYear = currentDate.getFullYear();
      ApiCallGetAllocations(jobMonth, jobYear);
    } catch (error: any) {
      console.error("Error Assigning Shopper.", error);
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message);
    }
  }
  const handleCloseDialog = () => {
    setOpenIssueDialog(false)
    setVisitTimesValues([]);
    setSelectedShopper(null)
    setSelectedDate(new Date());
  }
  useEffect(() => {
    if (selectedDateRedux) {
      setCurrentDate(new Date(selectedDateRedux))
    }
  }, [selectedDateRedux])

  const handleSelectNearbyShopper = (allocationId: number, userId: number) => {
    setSelectedNearbyShoppers((prev) => {
      const currentSelected = prev[allocationId] || [];
      if (currentSelected.includes(userId)) {
        return {
          ...prev,
          [allocationId]: currentSelected.filter((id) => id !== userId)
        };
      } else {
        return {
          ...prev,
          [allocationId]: [...currentSelected, userId]
        };
      }
    });
  };

  const handleInviteSelectedShoppers = async (allocationId: number) => {
    const selectedUserIds = selectedNearbyShoppers[allocationId] || [];
    const result = {
      allocationId: allocationId,
      userIds: selectedUserIds,
      createdBy: Number(localStorage.getItem('createdBy'))
    };
    try {
      const response = await ApiPostInviteShopper(result)
      toast.success('Selected Shoppers Invited Successfully!')
      setOpenNearest(false);
      setSelectedNearbyShoppers((prev) => {
        const updated = { ...prev };
        delete updated[allocationId];
        return updated;
      });
    }
    catch (error) {
      console.error('Error updating store:', error)
      toast.error("Error Inviting Shopper.");
    }
  };

  const handleCancelJob = async (allocationId: number) => {
    const isDetelte = window.confirm("Are you sure you want to delete this allocation ?")
    if (isDetelte) {
      const data = `?allocationId=${allocationId}`
      try {
        const response: any = await ApiPutCancelJob(data)
        toast.success("Allocation Cancelled successfully!")
        const jobMonth = currentDate.getMonth() + 1
        const jobYear = currentDate.getFullYear()
        await ApiCallGetAllocations(jobMonth, jobYear, currentPage) // Keep current page after cancellation
      } catch (error: any) {
        console.error("Error during API call:", error)
        toast.error(error)
      }
    }
  }
  useEffect(() => {
    if (allocations.length > 0) {
      const currentPageIds = allocations.map((a: any) => a?.allocationId);
      const allSelected = currentPageIds.every((id: string) => selectedAllocations.includes(id));
      setSelectAll(allSelected);
    }
  }, [allocations, selectedAllocations]);
  const clearSelections = () => {
    setSelectedAllocations([]);
    setSelectAll(false);
  };

  const handleCancelShopper = async (allocationId: number) => {
    try {
      const response = await ApiGetCancelledShopper(`?allocationId=${allocationId}`)
      setCancelledShopper(response.data);
      setOpenCancelledDialog(true);
    } catch (error) {
      console.error("Error Generating cancelled shopper.", error);
      toast.error("Error getting cancelled shopper.")
    }
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      setSelectedFiles(Array.from(files));
    }
  };

  const handleRemoveFile = (index: number, isUploaded: boolean = true) => {
    setSelectedFiles(prev => {
      const updatedFiles = [...prev];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };


  const handleImportBulkAssignShopper = async () => {
    if (!tempclientEntityId || selectedFiles.length === 0) {
      toast.error("Please select a client entity and upload a file");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("clientEntityId", tempclientEntityId);
      formData.append("file", selectedFiles[0]);

      const res = await ApiImportBulkAssignShopper(formData);
      if (res?.status) {
        setSelectedFiles([]);
        setTempClientEntityId(null)
        setSelectedClient(null)
        toast.success(res?.message)
        setOpenBulkImport(false)
      }

    } catch (error: any) {
      console.error("Import failed:", error);
      toast.error(error?.response?.data?.message || "Failed to import Email Preference");
    } finally {
    }
  };


  const handleAddNote = async () => {
    if (siteNote?.trim()?.length < 1) {
      alert("Please add a note")
      return
    }
    try {
      const data =
      {
        notes: siteNote,
        ...(selectedNoteId
          ? {
            adminVenueNoteId: selectedNoteId,
            modifiedBy: Number(localStorage.getItem("createdBy")),
          }
          : {
            venueId: selectedAllocationFC?.venueId?.venueId,
            createdBy: Number(localStorage.getItem("createdBy")),
          })
      }
      const res = selectedNoteId ? await ApiUpdateVenueNotes(data) : await ApiCreateVenueNotes(data)
      if (res?.status || res?.success) {
        setOpenAddNote(false)
        setSiteNote("")
        setSelectedNoteId(null)
        ApiCallGetCriteria(selectedAllocationFC?.allocationId, selectedAllocationFC?.venueId?.clientEntityId?.clientEntityId ?? selectedAllocationFC?.clientEntityId?.clientEntityId)

      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const handleDeleteSiteNote = async (id: number) => {
    const isConfirm = window.confirm("Are you sure you want to delte this site note ?")
    if (isConfirm) {
      try {
        const data = `?adminVenueNoteId=${id}`
        const res = await ApiDeleteVenueNotes(data)
        if (res?.success || res?.status) {
          ApiCallGetCriteria(selectedAllocationFC?.allocationId, selectedAllocationFC?.venueId?.clientEntityId?.clientEntityId ?? selectedAllocationFC?.clientEntityId?.clientEntityId)
        }
      } catch (error: any) {
        toast.error(error?.message)
      }
    }
  }

  const handleGetShopperAppliedAllocation = async (allocation: any) => {
    setAppliedAllocation([])
    let data = `?offset=0&limit=10&allocationStatus=shopper_applied&status=applied&allocationId=${allocation.allocationId}`
    if (venueNameValue) data += `&venueId=${venueNameValue}`
    if (clientEntityId) data += `&clientEntityId=${clientEntityId}`
    if (selectedClient?.clientGroupName) data += `&allocationClientGroup=${selectedClient.clientGroupName}`
    try {
      const res: any = await ApiGetAppliedAllocations(data)
      if (res?.status) {
        if (res?.data?.length < 1) {
          return
        }
        setAppliedAllocation(res.data)
      }
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)

    }
  }

  const handleGetApproveAllocationShopper = async (allocation: any) => {
    setShoppers([])
    if (!allocation?.venueId?.venueId) return
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const data = `?venueId=${allocation?.venueId?.venueId}&jobMonth=${currentMonth}&jobYear=${currentYear}`
    try {
      const res: any = await ApiGetApproveAllocationShopper(data)
      if (res?.status) {
        if (res.data?.previousMonth) {
          res.data.previousMonth.sort((a: any, b: any) => {
            if (a.year !== b.year) {
              return a.year - b.year
            }
            return a.month - b.month
          })
        }

        if (res.data?.futureMonth) {
          res.data.futureMonth.sort((a: any, b: any) => {
            if (a.year !== b.year) {
              return a.year - b.year
            }
            return a.month - b.month
          })
        }
        setShoppers(res.data)
      }
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)

    }
  }

  const handleGetAllocationCriteria = async (shopperApplied: any) => {
    setAllocationCriteria([])
    if (!shopperApplied) return
    // console.log(shopperApplied)
    const data = `?allocationId=${shopperApplied?.allocationId}&clientEntityId=${shopperApplied?.clientEntityId?.clientEntityId}`
    const response = await ApiGetAllocationCriteriaDetails(data)
    setAllocationCriteria(response.data)
  }

  const handleClickOpen = () => { setOpenApplications(true) }

  const handleIconClick = async (shopperApplied: any) => {
    // const issues = getIssuesFromAllocationCriteria(allocationCriteria, shopperApplied.selectedVisitDate)
    try {
      const data = `?allocationId=${shopperApplied.allocationId?.allocationId}&clientEntityId=${shopperApplied?.allocationId?.clientEntityId.clientEntityId}&shopperId=${shopperApplied?.userId?.userId}`
      const res = await ApiGetAllocationWarning(data)
      if (res?.success || res?.status) {
        setIssueList(res?.data)
        setOpenIssueDialog(true)
      }

    } catch (error: any) {
      toast.error(error?.message)
    }

  }

  useEffect(() => {
    if (appliedAllocation?.length > 0) {
      const defaults: { [key: number]: number | null } = {};
      appliedAllocation.forEach((shopperApplied: any, index: number) => {
        defaults[index] = shopperApplied?.selectedVisitTime?.visitTimeId || null;
      });
      setSelectedVisitTimeIds(defaults);
    }
  }, [appliedAllocation]);

  const handleUpdateAppliedAllocation = async (shopperApplied: any, status: any, index: any) => {
    const visitDate = editedDates[index]
      ? editedDates[index].format('YYYY-MM-DD')
      : dayjs(shopperApplied.selectedVisitDate).format('YYYY-MM-DD');
    const data = {
      userId: shopperApplied.userId.userId,
      allocationId: shopperApplied.allocationId.allocationId,
      status: status,
      visitDate: visitDate,
      visitTime: selectedVisitTimeIds[index],
      modifiedBy: Number(localStorage.getItem("createdBy")),
      ...(skipTrainingStatus[index] && { isSkipTraining: true })

    }
    // console.log("Send Data", data)
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiPostUpdateAppliedAllocationStatus(data)
      setOpenApplications(false)
      toast.success("Allocation Approved successfully")
      ApiCallGetAllocations(jobMonth, jobYear, currentPage)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }


  const handleRejectAppliedAllocation = async (shopperApplied: any) => {

    const data = `?appliedAllocationId=${shopperApplied?.appliedAllocationId}`
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res = await ApiRejectAppliedAllocation(data)
      setOpenApplications(false)
      toast.success("Allocation Requested successfully")
      ApiCallGetAllocations(jobMonth, jobYear, currentPage)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }

  }


  const handleHoldAppliedAllocation = async (shopperApplied: any) => {

    const data1 = `?userId=${shopperApplied.userId.userId}&allocationId=${shopperApplied.allocationId.allocationId}`
    const data2 = {
      holdReason: reasonforhold,
      isHold: true,
      holdById: Number(localStorage.getItem("createdBy")),
    }
    // console.log("Data1", data1)
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiHoldAppliedAllocation(data1, data2)
      setOpenApplications(false)
      toast.success("Allocation Hold successfully")
      ApiCallGetAllocations(jobMonth, jobYear, currentPage)
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
    finally { setreasonforhold(''); setOpenHoldReason(false); }
  }


  const handleGetShopperAppliedBundleAllocation = async (allocation: any) => {
    setgroupAppliedAllocation([])
    setShopperDetailsForTransBundle([])
    // setShopperDetailsfornormalbundle([])
    const data = `?offset=0&limit=1000&withoutVenueBundleAllocationId=${allocation.bundleId}`
    try {
      const res: any = await ApiGetNewAppliedBundleAllocation(data)
      if (res?.data?.length == 0) {
        toast.info("No applications found")
        return
      }
      setAppliedData(res.data)
      // console.log("Apploed Data", appliedData);
      setBundlleId(allocation.bundleId)
      setAppliedAllocation(res.data)
      const groupedArray: any = [];

      res?.data?.forEach(item => {
        const existing = groupedArray.find(entry => entry.userId === item.userId.userId);
        if (existing) {
          existing.data.push(item);
        } else {
          groupedArray.push({
            userId: item.userId.userId,
            data: [item]
          });
        }
      });
      if (res?.data?.length > 0) {
        res.data.forEach((item: any) => {
          if (item?.allocations && item.allocations.length > 0) {
            item.allocations.forEach((alloc: any) => {
              getPFshoppersForTransportBundle(alloc);
            });
          }
        });
      }
      setgroupAppliedAllocation(groupedArray)
      setOpenApplications(true)

    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  const getPFshoppersForTransportBundle = async (allocation: any) => {
    if (!allocation?.venueId?.venueId) {
      return;
    }

    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const data = `?venueId=${allocation?.venueId?.venueId}&jobMonth=${currentMonth}&jobYear=${currentYear}`

    try {
      const res: any = await ApiGetApproveAllocationShopper(data)
      if (res.data?.previousMonth) {
        res.data.previousMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return b.year - a.year
          }
          return b.month - a.month
        })
      }

      if (res.data?.futureMonth) {
        res.data.futureMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return a.year - b.year
          }
          return a.month - b.month
        })
      }
      setShopperDetailsForTransBundle((prev) => ({
        ...prev,
        [allocation?.allocationId]: res.data
      }));
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const getPFshoppersforbundleAllocations = async (allocation: any) => {
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const data = `?venueId=${allocation?.venueId?.venueId}&jobMonth=${currentMonth}&jobYear=${currentYear}`
    try {
      const res: any = await ApiGetApproveAllocationShopper(data)
      if (res.data?.previousMonth) {
        res.data.previousMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return b.year - a.year
          }
          return b.month - a.month
        })
      }

      if (res.data?.futureMonth) {
        res.data.futureMonth.sort((a: any, b: any) => {
          if (a.year !== b.year) {
            return a.year - b.year
          }
          return a.month - b.month
        })
      }
      setShopperDetailsfornormalbundle((prev) => ({
        ...prev,
        [allocation?.allocationId]: res.data
      }));
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  const handleGetShopperAppliedNormalBundleAllocation = async (allocation: any) => {
    // setAppliedData([])
    setgroupAppliedAllocation([])
    setShopperDetailsfornormalbundle([])
    const data = `?offset=0&limit=100&allocationStatus=applied&bundleId=${allocation.bundleId?.bundleId}`
    try {
      const res: any = await ApiGetAppliedBundleAllocations(data)
      if (res?.data?.length == 0) {
        toast.info("No applications found")
      }
      setAppliedAllocation(res.data[0])
      // console.log("Total Item", res.data[0].appliedAllocations)
      const groupedArray: any = [];
      if (res.data) {
        const data = res.data[0]?.appliedAllocations?.map((allocation: any) => ({
          [allocation?.appliedAllocationId]: {
            allocationId: allocation?.allocationId?.allocationId,
            venueName: allocation?.allocationId?.venueId?.venueName,
            visitDate: allocation?.selectedVisitDate?.split(" ")[0],
            visitTime: allocation?.selectedVisitTime?.visitTimeId,
            userId: allocation?.userId?.userId
          }
        }));
        setSendBundleData(data)
      }

      res.data[0].appliedAllocations.forEach(item => {
        const existing = groupedArray.find(entry => entry.userId === item.userId.userId);
        if (existing) {
          existing.data.push(item);
        } else {
          groupedArray.push({
            userId: item.userId.userId,
            data: [item]
          });
        }
      });
      groupedArray[0]?.data?.map((item: any) => {
        getPFshoppersforbundleAllocations(item?.allocationId)
      })
      setOpenApplications(true)
      setgroupAppliedAllocation(groupedArray)

    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }


  const handleHoldBundleAppliedAllocation = async (bundleId: any, userId: any) => {

    const data1 = `?userId=${holdId}&bundleId=${bundleId}`
    const data2 = {
      holdReason: reasonforhold,
      isHold: true,
      holdById: Number(localStorage.getItem("createdBy")),
    }

    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiHoldBundleAppliedAllocation(data1, data2)
      setOpenApplications(false)
      toast.success("Allocation Hold successfully")
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
    finally { setreasonforhold(''); setOpenHoldReason(false); }
  }

  const handleRejectBundle = async (bundleId: any, userId: any) => {
    try {
      const data = `?bundleId=${bundleId}&userId=${userId}`
      const res = await ApiRejectBundleAllocation(data);
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      setOpenApplications(false)
      toast.success(res?.message)
      ApiCallGetAllocations(jobMonth, jobYear, currentPage)
    } catch (error: any) {
      console.error("Error Rejecting Bundle.", error)
      toast.error(error)
    }
  }

  const handleUpdateBundleAppliedAllocation = async (bundleId: any, userId: any, status: any) => {
    const data = {
      userId: userId,
      // bundleId: bundleId,
      status: status,
      allocations: sendBundleData
        .filter((obj: any) => {
          const key = Object.keys(obj)[0];
          return obj[key]?.userId === userId;
        })
        .map((obj: any) => {
          const key = Object.keys(obj)[0];
          const val = obj[key];

          return {
            allocationId: val.allocationId,
            visitDate: val.visitDate,
            visitTime: String(val.visitTime)
          };
        }),
      modifiedBy: Number(localStorage.getItem("userId")),
    }
    // console.log("Send Approve Data", data)
    try {

      const res: any = await ApiPostUpdateBundleAppliedAllocationStatus(data)
      toast.success("Bundle Allocation Approved successfully")
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      setOpenApplications(false)
      ApiCallGetAllocations(jobMonth, jobYear, currentPage)
      // GetNormalBundleAllocations()
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  const handleBundlleShopperApprove = async (approveShopperBundle: any, status: any) => {
    const data = {
      withoutVenueBundleAllocationId: bundleId,
      userId: approveShopperBundle.userId.userId,
      status: status,
      modifiedBy: Number(localStorage.getItem("userId"))
    }
    try {
      const response = await ApiApproveShopperBundle(data)
      toast.success(response.message);
      const jobMonth = currentDate.getMonth() + 1;
      const jobYear = currentDate.getFullYear();
      setOpenApplications(false)
      ApiCallGetAllocations(jobMonth, jobYear, currentPage)
    } catch (error) {
      console.error("Error Approving Data.", error);
      toast.error("Error Approving Data.")
    }
  }
  console.log('Brief', brief)
  return (
    <div className="w-100 p-2">
      <Box className='p-2 bg-white border-10'>
        <Box>
          <Stack spacing={3}>
            <Grid container className='w-100 mt-3  align-items-center'>
              <Grid className='mb-4' size={{ xs: 12, md: 12 }}>
                <Typography className="text-center fs-42">
                  Orphan Allocation
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    // marginBottom: {xs:"0px",md:"-70px"},
                    flexWrap: 'wrap',
                    gap: 2,
                    marinTop: "23px",
                  }}
                >
                  <Stack direction="row" flexWrap={{ xs: "wrap", md: "nowrap" }} gap={1}>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                      <Autocomplete
                        disablePortal
                        id="mm-autocomplete"
                        options={Clientlist}
                        value={selectedClient}
                        getOptionLabel={(option) => option?.clientGroupName}
                        isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                        onChange={(event, newValue: any) => {
                          // setSelectedClient(newValue)
                          dispatch(setSelectedClientGroup(newValue))
                          setClientId(newValue?.clientGroupName || null)
                          setClientEntityId(null)
                          setVenueNameValue(null)
                          setClientEntityList([])
                        }}
                        // defaultValue="mmcommon"
                        renderInput={(params) => <TextField {...params} label="Select Client" />}
                        size="small"
                      />
                    </FormControl>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                      <Autocomplete
                        disablePortal
                        id="beacon-autocomplete"
                        options={clientEntityList.filter((item: any) => item.clientEntityId !== null)}
                        getOptionLabel={(option) => option?.entityName || ""}
                        onChange={(event, newValue: any) => {
                          setClientEntityId(newValue?.clientEntityId || null)
                          if (newValue?.entityName === "Liquor ID") {
                            sessionStorage.setItem("isLiquor", "true");
                          } else {
                            sessionStorage.setItem("isLiquor", "false");
                          }
                          if (!newValue) {
                            setVenueNameValue(null)
                            sessionStorage.setItem("isLiquor", "false");
                          }
                        }}
                        value={clientEntityList.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                        renderInput={(params) => <TextField {...params} label="Select Business" />}
                        size="small"
                      />
                    </FormControl>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 200 } }}>
                      <Autocomplete
                        disablePortal
                        id="mm-autocomplete"
                        options={venueName}
                        getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                        value={venueName.find((option: any) => option.value === venueNameValue) || null}
                        onChange={(event, newValue: any) => {
                          setVenueNameValue(newValue?.value || null)
                          setSearchText("")
                        }}
                        defaultValue=""
                        renderInput={(params) => <TextField {...params} label="Search Site" />}
                        size="small"
                      />
                    </FormControl>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                      <Autocomplete
                        disablePortal
                        id="mm-autocomplete"
                        options={stateOptions}
                        getOptionLabel={(option: any) => `${option?.label}`}
                        value={stateOptions.find((option: any) => option.value === state) || null}
                        onChange={(event, newValue: any) => {
                          setState(newValue?.value || null)
                        }}
                        defaultValue=""
                        renderInput={(params) => <TextField {...params} label="Select State" />}
                        size="small"
                      />
                    </FormControl>
                  </Stack>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // marginBottom: "70px",
                    }}
                  >
                    <IconButton onClick={handlePrevMonth}>
                      <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                      <input
                        type="month"
                        value={formatDate(currentDate)}
                        onChange={handleDateChange}
                        className="primary-color"
                        style={{
                          border: "none",
                          background: "none",
                          fontSize: "1.25rem",
                          fontWeight: "bold",
                          cursor: "pointer",
                          fontFamily: "inherit",
                        }}
                      />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                      <ChevronRightIcon />
                    </IconButton>
                  </Box>
                  <Stack direction="row" sx={{ width: { md: "auto", xs: "100%" } }} flexWrap={"wrap"}>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 300 } }}>
                      <TextField
                        label="Search"
                        size="small"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </FormControl>
                  </Stack>
                </Box>
              </Grid>
            </Grid>

            <Box className='d-flex align-items-center mb-4 my-0 flex-wrap justify-content-between'>
              <Box className='d-flex align-items-center'>
                <Typography fontWeight={'900'} variant="subtitle2">Select All</Typography>
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              </Box>
              <Box className="justify-content-between align-items-center d-flex" gap={1}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className="table-row-background"
                  onClick={() => { setOpenBulkImport(true) }}
                >Bulk Assign Shopper</Button>

                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className="table-row-background"
                  onClick={() => { setOpen(true) }}
                >Assign Selected Shopper</Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className="table-row-background"
                  onClick={() => { setshowdateselect(true) }}
                >Update Details</Button>
              </Box>
            </Box>

            <Grid
              container
              spacing={4}
              className="mt-0"
              style={{
                gap: "20px",
                // paddingRight: "32px",
                flexWrap: "nowrap",
                // gridTemplateColumns: "1fr 1fr",
                display: "block",
              }}
            >
              <Box
                className="table-row-background"
                sx={{
                  display: { xs: "none", sm: "block" },
                  color: "white",
                  borderRadius: "5px",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "16px",
                  }}
                >
                  <div style={{ flexGrow: 1, width: "50%" }}>Venue</div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      paddingRight: "20px",
                      width: "50%",
                      gap: '120px',
                      // flexWrap: "wrap",
                    }}
                  >

                    <Box sx={{ minWidth: { xs: "200px", xl: '300px' }, textAlign: 'center' }}>Previous Shoppers</Box>
                    <Box sx={{ minWidth: { xs: "200px", xl: '300px' }, textAlign: 'center' }}>Future Shoppers</Box>
                    <Box>Actions</Box>
                  </div>
                </div>
              </Box>
              {allocations?.map((allocation: any, index: any) => (
                <Grid
                  size={{ xs: 12, md: 12 }}
                  style={{
                    padding: "0px",
                    boxShadow: "none",
                    marginBottom: "20px",
                  }}
                  // item
                  // xs={12}
                  // md={6}
                  key={index}
                >

                  <Card className="min-border-color" style={{ boxShadow: "none" }} sx={{}}>

                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: { xs: "column", lg: "row" }
                        }}
                      >
                        <Box className='d-flex align-items-start' width={{ xs: "100%", lg: '45%' }} flexDirection={{ xs: "column", md: "row" }} gap={0}>
                          <Box className="d-flex align-items-center mr-2">
                            <Box className='d-flex align-items-center '>
                              <Checkbox
                                checked={selectedAllocations.includes(allocation?.allocationId)}
                                onChange={() => handleSelectCard(allocation?.allocationId)}
                              />
                            </Box>
                            <Box component={'img'} flex={1} maxHeight={'50px'} maxWidth={'100px'} src={allocation?.venueId?.logoUrl} />
                          </Box>
                          <Box sx={{ flexGrow: 1, width: { md: "100%", xs: "100%" } }}>
                            <div className="d-flex align-items-center" style={{ gap: "20px" }}>

                              <Typography variant="h6" gutterBottom sx={{ wordBreak: 'break-word' }}>
                                {allocation?.venueId?.venueName}
                              </Typography>
                              {allocation?.venueId?.clientEntityId?.entityTypeId?.entityTypeName && (
                                <Typography gutterBottom className="p-1 px-2" sx={{ borderRadius: "7px", backgroundColor: "#ADB792", color: "white", fontSize: "10px", }}>
                                  {allocation?.venueId?.clientEntityId?.entityTypeId?.entityTypeName}
                                </Typography>
                              )}
                              {allocation?.bundleId?.bundleId && <Typography className='p-1 px-2' sx={{ borderRadius: "7px", backgroundColor: "#ADB792", color: "white", fontSize: '12px' }}>Bundle: {allocation?.bundleId?.bundleName}</Typography>}
                              {allocation?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId && <Typography className='p-1 px-2' sx={{ borderRadius: "7px", backgroundColor: "#ADB792", color: "white", fontSize: '12px' }}>Bundle: {allocation?.withoutVenueBundleAllocationId?.bundleName}</Typography>}
                              {/* {allocation?.venueId?.shopTypeId?.shopTypeName && (
                              <Typography gutterBottom className="p-1" style={{border:"1px solid black", borderRadius:"7px", backgroundColor:"#ADB792", color:"white", fontSize:"10px"}}>
                               {allocation?.venueId?.shopTypeId?.shopTypeName}
                              </Typography>
                            )}                             */}
                            </div>

                            <Typography sx={{ wordBreak: 'break-word' }}>
                              <b>Address:</b> {allocation?.venueId?.address?.split(',')[0]}, {allocation?.venueId?.city} {allocation?.venueId?.state} {allocation?.venueId?.postalCode}, {allocation?.venueId?.country === "AU" ? 'Australia' : allocation?.venueId?.country}
                            </Typography>
                            {/* <Typography>
                          <b>Postcode:</b> {allocation?.venueId?.postalCode}
                        </Typography> */}
                            <Typography sx={{ wordBreak: 'break-word' }}>
                              <b>Trading hours:</b>
                              {allocation?.venueId?.tradingHours}
                            </Typography>
                            <Typography sx={{ wordBreak: 'break-word' }}>
                              <b>Website:</b> {allocation?.venueId?.websiteURL}
                            </Typography>
                            <Typography sx={{ wordBreak: 'break-word' }}>
                              <b>Price:</b> {allocation?.allocationPriceDisplay ? allocation?.allocationPriceDisplay : `${allocation?.allocationPrice}`}
                            </Typography>
                            <Typography sx={{ wordBreak: 'break-word' }}>
                              <b>Client name:</b> {allocation?.venueId?.clientEntityId?.entityName ?? allocation?.clientEntityId?.entityName}
                            </Typography>
                            <hr></hr>
                            <Box className="d-flex align-items-center" gap={2}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="table-row-background"
                                sx={{ marginBottom: "8px", width: { md: "170px", xs: "100%" } }}
                                onClick={() => {
                                  setOpenNearest(nearestOpen === allocation?.allocationId ? null : allocation?.allocationId)
                                  const newVenueId = allocation?.venueId?.venueId
                                  setCurrentAllocationId(allocation?.allocationId)
                                  ApiCallGetNearbyShopper(newVenueId, allocation?.allocationId)
                                  console.log("newVenueId", newVenueId)
                                }}
                              >
                                load Nearest
                              </Button>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="table-row-background"
                                sx={{ marginBottom: "8px", width: { md: "170px", xs: "100%" } }}
                                onClick={() => {
                                  setselectedAllocationFC(allocation)
                                  ApiCallGetCriteria(allocation?.allocationId, allocation?.venueId?.clientEntityId?.clientEntityId ?? allocation?.clientEntityId?.clientEntityId)
                                }}
                              >
                                View Criteria
                              </Button>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="table-row-background"
                                sx={{ marginBottom: "8px", width: { md: "170px", xs: "100%" } }}
                                onClick={() => {
                                  getBrief(allocation?.venueId?.venueId, allocation?.venueId?.clientEntityId?.clientEntityId ?? allocation?.clientEntityId?.clientEntityId)
                                }}
                              >
                                Brief
                              </Button>
                            </Box>
                            {nearestOpen === allocation?.allocationId && nearbyShopper?.length > 0 && (
                              <div>
                                <div className="nearest-table min-border-color" style={{ overflow: "auto" }}>
                                  <table>
                                    <thead className="table-row-background" style={{ color: "white" }}>
                                      <tr>
                                        <th>Select</th>
                                        <th>Shopper</th>
                                        <th>Phone</th>
                                        <th>Distance(kms)</th>
                                        <th>Dob</th>
                                        <th>Age</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {nearbyShopper?.map((item: any, index: any) => (
                                        <tr key={index}>
                                          <td>
                                            <Checkbox
                                              checked={selectedNearbyShoppers[allocation?.allocationId]?.includes(item.userId) || false}
                                              onChange={() => handleSelectNearbyShopper(allocation?.allocationId, item.userId)}
                                            />
                                          </td>
                                          <td>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              size="small"
                                              className="table-row-background"
                                              style={{
                                                width: "100%",
                                              }}
                                              // onMouseEnter={(e) => {
                                              //   handleHover(e, index, item.userId)
                                              // }}
                                              onClick={(e) => handleShopperDetailsClick(e, item.userId)}
                                            >
                                              {item.firstName} - {item.lastName}
                                            </Button>
                                          </td>
                                          <td>{item.contactNo}</td>
                                          <td>{item.distanceInKm.toFixed(2)}</td>
                                          <td>{dayjs(item.dob).format("DD/MM/YYYY")}</td>
                                          <td>{dayjs().diff(dayjs(item.dob), "year")}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                                <div style={{ textAlign: "right" }}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    className="table-row-background"
                                    style={{ marginTop: "20px", width: "auto" }}
                                    onClick={() => handleInviteSelectedShoppers(allocation?.allocationId)}
                                  >
                                    Invite Selected shoppers
                                  </Button>
                                </div>
                              </div>
                            )}
                          </Box>
                        </Box>
                        <Popover
                          // open={Boolean(anchorEl) && selectedIndex === index}
                          open={Boolean(anchorEl) && clickedShopperId !== null}
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                        >
                          <Dcrage handleClose={handleClose} loanData={loanData} />
                        </Popover>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "start",
                            // marginLeft: "16px",
                            justifyContent: { md: "end", xs: "center" },
                            gap: "10px",
                            flexWrap: { xs: "wrap", lg: "nowrap" },
                            width: { lg: "50%", xs: "100%" },
                          }}
                        >
                          <Box className="mt-2" sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: "20px", xl: "120px" }, alignItems: { xs: "center", md: "start" }, width: { xs: "100%", md: "auto" } }} >
                            <Box width={'300px'}>
                              <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                                Previous Shoppers:
                              </Typography>
                              {allocation?.previousShoppers?.length > 0 ? (
                                <Box className='d-flex justify-content-end' flexWrap={'wrap'} sx={{ gap: "10px" }}>
                                  {allocation.previousShoppers.map((shopper: any, i: number) => (
                                    <Box
                                      // variant="contained"
                                      // color="primary"
                                      // size="small"
                                      // className="table-row-background mb-2"
                                      sx={{ marginBottom: "0px", fontSize: '14px', cursor: 'pointer', color: 'rgb(106,103,67)', textDecoration: 'underline', textDecorationColor: 'rgb(106,103,67)', width: { xs: "48%", md: "48%" } }}
                                      // onMouseEnter={(e) => {
                                      //   if (allocation?.secondLastShopperDetail) {
                                      //     handleHover(e, index, allocation?.secondLastShopperDetail?.shopperId)
                                      //   }
                                      // }}
                                      onClick={(e) => {
                                        if (shopper.shopperId) {
                                          handleShopperDetailsClick(e, shopper.shopperId)
                                        }
                                      }}
                                    >
                                      {shopper.shopperName}&nbsp;({shopper.completedOn})
                                    </Box>
                                  ))}
                                </Box>
                              ) : (
                                <></>
                                // <Button variant="contained" color="primary" size="small" className="table-row-background px-5">
                                //   N/A
                                // </Button>
                              )}
                            </Box>
                            <Box width={'310px'}>
                              <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                                Future Shopper:
                              </Typography>
                              {allocation?.futureShoppers?.length > 0 ? (
                                <Box className='d-flex justify-content-end' flexWrap={'wrap'} sx={{ gap: "10px" }}>
                                  {allocation.futureShoppers.map((shopper: any, i: number) => (
                                    <Box
                                      // variant="contained"
                                      // color="primary"
                                      // size="small"
                                      // className="table-row-background mb-2"
                                      // sx={{ marginBottom: "0px", textDecoration:'underline', width: { md: "150px", xs: "100%" } }}
                                      sx={{ marginBottom: "0px", fontSize: '14px', cursor: 'pointer', color: 'rgb(106,103,67)', textDecoration: 'underline', textDecorationColor: 'rgb(106,103,67)', width: { xs: '48%', md: "48%" } }}
                                      // onMouseEnter={(e) => {
                                      //   if (allocation?.lastShopperDetail) {
                                      //     handleHover(e, index, allocation?.lastShopperDetail?.shopperId)
                                      //   }
                                      // }}
                                      onClick={(e) => {
                                        if (shopper?.shopperId) {
                                          handleShopperDetailsClick(e, shopper.shopperId)
                                        }
                                      }}
                                    >
                                      {/* <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}> */}
                                      {shopper.shopperName}&nbsp;
                                      ({shopper.completedOn})
                                    </Box>
                                    // </Button>
                                  ))}
                                </Box>
                              ) : (
                                <></>
                                // <Button variant="contained" color="primary" size="small" className="table-row-background px-5">
                                //   N/A
                                // </Button>
                              )}
                            </Box>
                          </Box>
                          <Box className="mb-0 mt-2" sx={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", width: { xs: "100%", md: "fit-content" } }}>
                            <Typography sx={{ display: { xs: "block", md: "none" }, fontWeight: 600 }}>
                              Actions:
                            </Typography>
                            <Link
                              to={`/admin/allocations/Invite-Shopper/${allocation?.allocationId}`}
                              // variant="contained"
                              // color="primary"
                              // size="small"
                              className="table-row-background text-center link-btn"
                              style={{ width: '100%', maxWidth: '170px' }}
                            // onClick={() => handelInvite(allocation)}
                            >
                              Invite Shopper
                            </Link>
                            {/* <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              className="table-row-background"
                              sx={{ width: { md: "150px", xs: "100%" } }}
                              onClick={() => handelInvite(allocation)}
                            >
                              Invite Shopper
                            </Button> */}
                            <Link
                              to={`/admin/allocations/assign-Shopper/${currentDate}/${allocation?.allocationId}`}
                              // variant="contained"
                              // color="primary"
                              // size="small"
                              className="table-row-background text-center link-btn"
                              style={{ width: "100%", maxWidth: "170px" }}
                              onClick={(e) => {
                                if (
                                  allocation?.bundleId?.bundleId ||
                                  allocation?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId
                                ) {
                                  e.preventDefault();
                                  window.alert(
                                    "This task is part of a bundle and cannot be assigned individually."
                                  );
                                }
                              }}
                            >
                              Assign Shopper
                            </Link>
                            <Button
                              variant="outlined"
                              // color="danger"
                              size="small"
                              sx={{ background: "#FF00001A", color: "#FF0000", borderColor: "#FF0000", width: { md: "150px", xs: "100%" }, whiteSpace: "nowrap" }}

                              // className="table-row-background"
                              onClick={() => handleCancelJob(allocation?.allocationId)}
                            >
                              Delete Allocation
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              className="table-row-background py-2 px-3"
                              sx={{ width: { md: "150px", xs: "100%", whiteSpace: 'nowrap', textTransform: 'none' } }}
                              onClick={() => handleCancelShopper(allocation?.allocationId)}
                            >
                              Cancelled Shopper
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              className="table-row-background"
                              sx={{ marginBottom: "8px", width: { md: "170px", xs: "100%", textTransform: 'none' } }}
                              onClick={async () => {
                                setIsActive(false)
                                setIsActive1(false)
                                if (allocation?.bundleId) {
                                  setIsActive1(true)
                                  await handleGetShopperAppliedNormalBundleAllocation(allocation)

                                }
                                else if (allocation?.withoutVenueBundleAllocationId) {
                                  setIsActive(true)
                                  await handleGetShopperAppliedBundleAllocation(allocation)

                                }
                                else {
                                  await handleGetVisitTimeList()
                                  await handleGetShopperAppliedAllocation(allocation)
                                  await handleGetApproveAllocationShopper(allocation)
                                  await handleGetAllocationCriteria(allocation)
                                  handleClickOpen()
                                }
                              }}
                            >
                              Past Applications
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Stack>

          {/* Updated Pagination - now uses totalCount from API */}
          {totalCount > itemsPerPage && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "70px",
              }}
            >
              <Pagination
                count={Math.ceil(totalCount / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          )}
        </Box>
        <Dialog open={showdateselect}>
          <DialogContent>
            <Box className='d-flex align-items-center justify-content-end'>
              <IconButton onClick={() => { setshowdateselect(false) }}><CancelOutlined /></IconButton>
            </Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                value={selectedNewDate}
                onChange={(newValue) => setSelectedNewDate(newValue)}
                views={["month", "year"]}
              />
            </LocalizationProvider>
            <Box className='d-flex align-items-center justify-content-center'>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className="table-row-background"
                onClick={() => { handleUpateDetails() }}
              >Update</Button>
            </Box>
          </DialogContent>
        </Dialog>
        <Dialog open={open} maxWidth="sm" fullWidth>
          <DialogContent sx={{ height: "320px", }}>
            <Box display="flex" justifyContent="flex-end">
              <IconButton onClick={() => { setOpen(false); setSelectedDate(null); setSelectedShopper(null); setVisitTimesValues([]); }}>
                <CancelOutlined />
              </IconButton>
            </Box>
            <Stack spacing={2} alignItems="stretch" mt={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Select Visit Date"
                  value={selectedDate}
                  minDate={startOfMonth(currentDate)}
                  maxDate={endOfMonth(currentDate)}
                  onChange={(newDate: any) => { setSelectedDate(newDate) }}
                  format="dd/MM/yyyy"
                  slotProps={{
                    textField: {
                      size: "medium",
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>
              <Autocomplete
                id="shopper-autocomplete"
                disablePortal
                options={shopperlist?.filter((item: any) => item?.firstName !== "")}
                value={selectedShopper}
                onInputChange={(event, newInputValue) => {
                  setsearchShopper(newInputValue);
                  if (newInputValue === "") setSelectedShopper(null);
                }}
                getOptionLabel={(option: any) =>
                  `${option?.firstName} ${option?.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                }
                isOptionEqualToValue={(option: any, value: any) =>
                  option.userId === value.userId || option.emailId === value.emailId
                }
                onChange={(event, newValue: any) => setSelectedShopper(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Shopper" size="medium" fullWidth />
                )}
              />
              <Autocomplete
                multiple
                options={visitTimes}
                disableCloseOnSelect
                getOptionLabel={(option) => option.visitTimeInformation}
                value={visitTimes?.filter((time) =>
                  visitTimesValues?.includes(time.visitTimeId.toString())
                )}
                onChange={(event, newValue) => {
                  setVisitTimesValues(
                    newValue.map((item) => item.visitTimeId.toString())
                  );
                }}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Checkbox
                      checked={visitTimesValues?.includes(option.visitTimeId.toString())}
                      style={{ marginRight: 8 }}
                    />
                    {option.visitTimeInformation}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Select Visit Times" size="medium" fullWidth />
                )}
              />
            </Stack>
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              size="small"
              className="table-row-background p-3"
              onClick={() => handleBulkAssign(selectedDate, selectedShopper, visitTimesValues)}
            >
              Assign Shopper
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openCriteria} maxWidth="md" fullWidth>
          <DialogContent>
            <Box display="flex" className='mb-3' justifyContent="space-between">
              <h3 style={{ fontWeight: '900' }}>{selectedAllocationFC?.venueId?.venueName}</h3>
              <IconButton onClick={() => { setOpenCriteria(false); setJobCriteria([]); setselectedAllocationFC([]) }}>
                <CancelOutlined />
              </IconButton>
            </Box>
            <Grid container spacing={2}>
              <Grid size={12}>
                <Typography
                  variant="h6">
                  <b> Available Days:</b> <span>{selectedAllocationFC?.visitDaysInformation ?? jobCriteria?.visitDaysInformation}</span>
                </Typography>
              </Grid>
              <Grid size={12} className='d-flex align-items-start' gap={1}>
                <Typography
                  whiteSpace={'nowrap'}
                  variant="h6"
                >
                  <b> Available Time: </b>
                </Typography>
                <Grid className='flex-1' container>
                  {selectedAllocationFC?.visitTimeInformation?.split(",")?.map((item: any) => (
                    <Grid size={12}>
                      <Typography variant="h6">{visitTimes?.find((item2: any) => item2?.visitTimeId == item)?.visitTimeInformation},
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid size={3}>
                <Typography
                  variant="h6"

                >
                  <b>min Date: </b>
                  {selectedAllocationFC?.minDate}
                </Typography>
              </Grid>
              <Grid size={3}>
                <Typography
                  variant="h6"
                >
                  <b>max Date: </b>  {selectedAllocationFC?.maxDate}
                </Typography>
              </Grid>
              <Grid size={3}>
                <Typography
                  variant="h6"
                >
                  <b>min Age: </b>  {selectedAllocationFC?.minAge}
                </Typography>
              </Grid>
              <Grid size={3}>
                <Typography
                  variant="h6"
                >
                  <b>max Age: </b>  {selectedAllocationFC?.maxAge}
                </Typography>
              </Grid>
              <Grid size={12}>
                <Typography variant="h6"> <b>Notes:</b></Typography>
                <Grid container spacing={2}>
                  {jobCriteria?.adminVenueNote?.map((item: any, index: number) => (
                    <Grid size={12} className='p-1' borderBottom={'1px dashed '} key={index}>
                      <Grid container justifyContent={'space-between'} spacing={2}>
                        <Grid size={12} className='d-flex' gap={1} justifyContent={'end'}>
                          <Typography variant="caption">
                            {dayjs
                              .tz(item?.modifiedOn || item?.createdOn, "Australia/Sydney")
                              .local()
                              .format("DD-MM-YYYY HH:mm")}
                          </Typography>
                          <Typography variant="caption">({item?.createdByFirstName}{item?.createdByLastName})</Typography>
                        </Grid>
                        <Grid size={'grow'}>
                          <Typography>{item?.notes}</Typography>
                        </Grid>
                        {item?.createdBy == localStorage.getItem('userId') && (
                          <>
                            <Grid size={'auto'} sx={{ cursor: 'pointer' }} onClick={() => { setSelectedNoteId(item?.adminVenueNoteId); setSiteNote(item?.notes); setOpenAddNote(true) }}>
                              <EditOutlined sx={{ color: '#ADB792' }} />
                            </Grid>
                            <Grid size={'auto'} sx={{ cursor: 'pointer' }} onClick={() => { handleDeleteSiteNote(item?.adminVenueNoteId) }}>
                              <DeleteOutlined sx={{ color: 'red' }} />
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Grid>

                  ))}
                </Grid>
              </Grid>
              <Grid size='auto'>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className="table-row-background mt-4"
                  onClick={() => { setOpenAddNote(true) }}
                >Add Notes</Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
        <Dialog open={openCancelledDialog} onClose={() => setOpenCancelledDialog(false)} maxWidth="md" fullWidth>
          <DialogContent>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ mb: 2, textAlign: "center" }}
            >
              Cancelled Shoppers
            </Typography>

            <TableContainer component={Paper} sx={{ border: "1px solid #ccc" }}>
              <Table>
                <TableHead sx={{ bgcolor: "#7a7d52" }}>
                  <TableRow>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>First Name</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Last Name</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Email</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Cancel Reason</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {cancelledShopper?.length > 0 ? (
                    cancelledShopper.map((item: any, index: any) => (
                      <TableRow key={index}>
                        <TableCell>{item.userId?.firstName}</TableCell>
                        <TableCell>{item.userId?.lastName}</TableCell>
                        <TableCell>{item.userId?.emailId}</TableCell>
                        <TableCell>{item.cancelReason}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No cancelled shoppers found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              sx={{ bgcolor: "#7a7d52", "&:hover": { bgcolor: "#5f6245" } }}
              onClick={() => setOpenCancelledDialog(false)}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openBulkImport} onClose={() => { setOpenBulkImport(false); setSelectedFiles([]); }} PaperProps={{
          sx: {
            width: '900px',
            height: 'fit-content',
            maxWidth: 'none'
          }
        }}>
          <DialogContent>
            <Typography variant="h5" className="mb-4" gutterBottom>
              Import Bulk Assign Shopper
            </Typography>

            <FormControl fullWidth size="small" className="mb-3">
              <Autocomplete
                disablePortal
                options={Clientlist}
                value={tempselectedClient}
                getOptionLabel={(option) => option?.clientGroupName || ""}
                isOptionEqualToValue={(option, value) =>
                  option.clientGroupDBName === value.clientGroupDBName
                }
                onChange={(event, newValue: any) => {
                  setTempSelectedClient(newValue);
                  setTempClientEntityId(null);
                  setClientEntityList([]);
                }}

                renderInput={(params) => (
                  <TextField {...params} label="Select Client" />
                )}
              />
            </FormControl>

            <FormControl fullWidth size="small" className="mb-3">
              <Autocomplete
                disablePortal
                options={tempclientEntityList.filter((item) => item.clientEntityId !== null)}
                getOptionLabel={(option) => option?.entityName || ""}
                value={
                  tempclientEntityList.find((option) => option?.clientEntityId === tempclientEntityId) || null
                }
                onChange={(event, newValue: any) =>
                  setTempClientEntityId(newValue?.clientEntityId || null)
                }
                renderInput={(params) => (
                  <TextField {...params} label="Select Business" />
                )}
              />
            </FormControl>
            <FormControl className='mt-3' fullWidth>
              <Grid container className='w-100' spacing={2}>
                {selectedFiles.map((file, index) => (
                  <Grid size={12} key={index}>
                    <Box
                      className='w-100'
                      sx={{
                        position: 'relative',
                        border: '1px solid',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        height: '150px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        p: 2
                      }}
                    >
                      {file.name.endsWith(".pdf") ? (
                        <PictureAsPdfOutlined color="error" fontSize="large" />
                      ) : file.name.endsWith(".xlsx") || file.name.endsWith(".xls") ? (
                        <DescriptionOutlined color="success" fontSize="large" />
                      ) : (
                        <InsertDriveFileOutlined color="action" fontSize="large" />
                      )}

                      <Typography variant="body2" noWrap sx={{ maxWidth: '100%', mt: 1 }}>
                        {file.name}
                      </Typography>

                      <IconButton
                        onClick={() => handleRemoveFile(index, false)}
                        sx={{
                          position: 'absolute',
                          top: 5,
                          right: 5,
                          bgcolor: 'white',
                          '&:hover': { bgcolor: 'grey.100' },
                        }}
                      >
                        <CancelOutlined color="error" />
                      </IconButton>
                    </Box>
                  </Grid>
                ))}

                {selectedFiles.length < 1 && (
                  <Grid size={12}>
                    <label htmlFor="file-upload" className="w-100" style={{ fontSize: '14px', color: 'grey' }}>
                      Upload Files
                      <Box
                        className="mt-2 w-100 d-flex align-items-center justify-content-center"
                        height={150}
                        border="1px dashed #00000033"
                        borderRadius={5}
                      >
                        <input
                          type="file"
                          id="file-upload"
                          accept=".pdf,.xlsx,.xls,.doc,.docx,.txt,.csv"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                          multiple
                        />
                        <Box className="d-flex flex-column align-items-center justify-content-center">
                          <Box className="border-blue" borderRadius="10px">
                            <FileUploadOutlined fontSize="medium" className="text-blue" />
                          </Box>
                          <Typography variant="caption">Upload Here</Typography>
                        </Box>
                      </Box>
                    </label>
                  </Grid>
                )}
              </Grid>
            </FormControl>

            <DialogActions>
              <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                <Button
                  variant="contained"
                  onClick={() => { setOpenBulkImport(false); setSelectedFiles([]); }}
                  className="table-row-background "
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleImportBulkAssignShopper()}
                  className="table-row-background "
                >
                  Submit
                </Button>
              </Stack>
            </DialogActions>
          </DialogContent>
        </Dialog>
        <Dialog open={openAddNote} maxWidth="xs" fullWidth>
          <DialogContent>
            <Box className='d-flex align-items-center justify-content-between'>
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ mb: 2 }}
              >
                Site Note
              </Typography>
              <IconButton onClick={() => {
                setOpenAddNote(false)
                setSiteNote("")
                setSelectedNoteId(null)
              }}><CancelOutlined /></IconButton>
            </Box>
            <TextField multiline fullWidth value={siteNote} placeholder="Enter note" onChange={(e) => { setSiteNote(e.target.value) }} />
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              sx={{ bgcolor: "#7a7d52", "&:hover": { bgcolor: "#5f6245" } }}
              onClick={() => handleAddNote()}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      <Dialog className="ApproveAllocation" fullWidth open={openApplication} onClose={() => { setOpenApplications(false) }}>
        <DialogContent className="dialog-content">
          <div
            style={{
              display: "flex ",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogTitle className="dialog-title">Approve applications</DialogTitle>
            <div
              style={{
                fontSize: "20px",
                fontWeight: "700",
                cursor: "pointer",
              }}
              onClick={() => { setOpenApplications(false) }}
            >
              X
            </div>
          </div>

          {(!isActive && !isActive1) ? (
            <div style={{ display: "flex" }}>
              <div className="previous-shoppers table-row-background">
                <h2 className="previous-shoppers__title">Previous Shoppers</h2>

                <div className="previous-shoppers__grid">
                  {shoppers?.previousMonth?.map((shopper: any, index: any) => (
                    <div className="previous-shoppers__item" key={index}>
                      <div className="previous-shoppers__month">{`${shopper?.month} - ${shopper?.year}`}</div>
                      <div className="previous-shoppers__name">{shopper?.shopperFirstName} {shopper?.shopperLastName}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="previous-shoppers table-row-background">
                <h2 className="previous-shoppers__title">Future Shoppers</h2>

                <div className="previous-shoppers__grid d-flex flex-wrap">
                  {shoppers?.futureMonth?.map((shopper: any, index: any) => (
                    <div className="previous-shoppers__item" key={index}>
                      <div className="previous-shoppers__month">{`${shopper?.month} - ${shopper?.year}`}</div>
                      <div className="previous-shoppers__name">{shopper?.shopperFirstName} {shopper?.shopperLastName}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          <Grid size={12}>
            <Typography variant="h6"> <b>Notes:</b></Typography>
            <Grid container spacing={2}>
              {allocationCriteria?.adminVenueNote?.map((item: any, index: number) => (
                <Grid size={12} className='p-1' borderBottom={'1px dashed '} key={index}>
                  <Grid container justifyContent={'space-between'} spacing={2}>
                    <Grid size={12} className='d-flex' gap={1} justifyContent={'end'}>
                      <Typography variant="caption">
                        {dayjs
                          .tz(item?.modifiedOn || item?.createdOn, "Australia/Sydney")
                          .local()
                          .format("DD-MM-YYYY HH:mm")}
                      </Typography>
                      <Typography variant="caption">({item?.createdByFirstName}{item?.createdByLastName})</Typography>
                    </Grid>
                    <Grid size={'grow'}>
                      <Typography>{item?.notes}</Typography>
                    </Grid>
                    {/* {item?.createdBy == localStorage.getItem('userId') && (
                               <>
                                 <Grid size={'auto'} sx={{ cursor: 'pointer' }} onClick={() => { setSelectedNoteId(item?.adminVenueNoteId); setSiteNote(item?.notes); setOpenAddNote(true) }}>
                                   <EditOutlined sx={{ color: '#ADB792' }} />
                                 </Grid>
                                 <Grid size={'auto'} sx={{ cursor: 'pointer' }} onClick={() => { handleDeleteSiteNote(item?.adminVenueNoteId) }}>
                                   <DeleteOutlined sx={{ color: 'red' }} />
                                 </Grid>
                               </>
                             )} */}
                  </Grid>
                </Grid>

              ))}
            </Grid>
          </Grid>
          <div className="applications">
            {!isActive && !isActive1 && (
              <div className="applications__header table-row-background">
                {/* <div className="applications__header-cell">Delete</div> */}
                <div className="applications__header-cell">Shopper Name</div>
                <div className="applications__header-cell text-start">Date</div>
                <div className="applications__header-cell">Time</div>
                <div className="applications__header-cell">Skip Training?</div>
                <div className="applications__header-cell">Issues</div>
                <div className="applications__header-cell">Action</div>
              </div>)}


            {(!isActive && !isActive1 && appliedAllocation?.length > 0) && appliedAllocation?.map((shopperApplied: any, index: any) => (
              <>
                <div className="applications__row" key={index}>

                  <div className="applications__cell " style={{ cursor: "pointer" }}>
                    <span
                      className="shopper-badge table-row-background"
                      onClick={(e) => {
                        handleShopperDetailsClick(e, shopperApplied.userId.userId)
                      }}
                    >
                      {shopperApplied.userId.firstName} {shopperApplied.userId.lastName}
                    </span>
                  </div>
                  <div className="applications__cell text-center">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={editedDates[index] || dayjs(shopperApplied.selectedVisitDate)}
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          setEditedDates((prev) => ({
                            ...prev,
                            [index]: newValue
                          }));
                        }}
                        minDate={dayjs(shopperApplied.selectedVisitDate).startOf("month")}
                        maxDate={dayjs(shopperApplied.selectedVisitDate).endOf("month")}
                        slotProps={{
                          textField: {
                            size: 'small',
                            sx: {
                              background: 'white',
                              borderRadius: '5px',
                              width: '130px'
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </div>

                  {/* <div className="applications__cell">{shopperApplied.selectedVisitTime.visitTimeInformation}</div> */}
                  {/* visitTimes */}
                  <div className="applications__cell">
                    <Autocomplete
                      options={visitTimes}
                      getOptionLabel={(option: any) => option.visitTimeInformation}
                      value={
                        !selectedVisitTimeIds[index] ?
                          visitTimes.find((v: any) => v.visitTimeId === shopperApplied.selectedVisitTime.visitTimeId) || null :
                          visitTimes.find((v: any) => v.visitTimeId === selectedVisitTimeIds[index]) || null}
                      onChange={(event, newValue: any) => {
                        setSelectedVisitTimeIds((prev) => ({
                          ...prev,
                          [index]: newValue ? newValue.visitTimeId : null
                        }));
                      }}

                      renderInput={(params) => <TextField {...params} label="Visit Time" size="small" fullWidth sx={{
                        // width:'fit-content',
                        minWidth: '300px',
                        "& .MuiInputBase-root": {
                          whiteSpace: "nowrap", // allow wrapping
                          overflow: "visible",  // don't hide overflow text
                        },
                        "& .MuiAutocomplete-input": {
                          textOverflow: "unset", // prevent text truncation
                        },
                      }} />}
                    />
                  </div>

                  <div className="applications__cell">
                    <Checkbox
                      checked={skipTrainingStatus[index] || false}
                      onChange={(e) => {
                        setSkipTrainingStatus((prev) => ({
                          ...prev,
                          [index]: e.target.checked
                        }));
                      }}
                    />
                  </div>
                  <div className="applications__cell">
                    <IconButton
                      size="small"
                      className="iconColor"
                      onClick={() => {
                        handleIconClick(shopperApplied)
                        // handleIconClick(shopperApplied)
                      }}
                    >
                      <Warning
                        sx={{
                          color: "gray",
                          cursor: "pointer",
                        }}
                      />
                    </IconButton>
                  </div>
                  <div className="applications__cell applications__actions d-flex align-items-center gap-1">
                    <Button
                      className="action-button action-button--approve table-row-background"
                      onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved", index)}
                    >
                      Approve
                    </Button>
                    <Tooltip
                      title={
                        shopperApplied?.isHold
                          ? shopperApplied?.holdReason || "NO Reason added"
                          : ""
                      }
                      arrow
                    >
                      <span>
                        <Button
                          className="action-button action-button--approve table-row-background"
                          disabled={shopperApplied?.isHold}
                          onClick={() => { setOpenHoldReason(true); setholdId(Card) }}
                        >
                          Hold
                        </Button>
                      </span>
                    </Tooltip>
                  </div>
                  {/* <div className="applications__cell applications__actions d-flex align-items-center gap-1">
                             <Button
                               className="action-button action-button--approve table-row-background"
                               onClick={() => handleRequestAppliedAllocation(shopperApplied, index)}
                             >
                               Request
                             </Button>
                           </div> */}
                  <div className="applications__cell applications__actions d-flex align-items-center gap-1">
                    <Button
                      className="action-button action-button--approve table-row-background"
                      onClick={() => handleRejectAppliedAllocation(shopperApplied)}
                    >
                      Reject
                    </Button>
                  </div>
                </div>

                <Dialog open={OpenHoldReason} onClose={() => { setOpenHoldReason(false); setholdId(shopperApplied.userId.userId) }}>
                  <DialogContent>
                    <TextField
                      required

                      className='p-0'
                      sx={{
                        width: '300px',
                        ".MuiOutlinedInput-input ": {
                          padding: '10px'
                        },
                        ".MuiInputLabel-root": {
                          top: '-6px'
                        }
                      }}
                      value={reasonforhold}
                      onChange={(e) => { setreasonforhold(e.target.value) }}
                      id="outlined-required"
                      label="Reason"
                    />
                    <Button sx={{ color: 'white' }} className="d-block mt-2  mx-auto action-button action-button--approve table-row-background"
                      onClick={() => { (reasonforhold.length > 0) ? handleHoldAppliedAllocation(shopperApplied) : alert("Reason is required") }}>
                      Submit
                    </Button>
                  </DialogContent>
                </Dialog>
              </>
            ))}
            {isActive && (
              <div className="applications__header2 table-row-background" style={{ justifyContent: "space-between !important" }}>
                {/* <div className="applications__header-cell">Delete</div> */}
                <div className="applications__header-cell text-center">Shopper Name</div>
                <div className="applications__header-cell text-center">Date</div>
                <div className="applications__header-cell text-center">Time</div>
                <div className="applications__header-cell text-center">Site</div>
                <div className="applications__header-cell text-center">Last Shopper</div>
                <div className="applications__header-cell text-center">2nd Last Shopper</div>
                <div className="applications__header-cell text-center">Future Shopper</div>
                <div className="applications__header-cell text-center">Action</div>
              </div>)}
            {isActive && appliedData?.map((Card, index) => (
              <>
                <div className="applications__row2" key={index}>
                  {/* <div className="applications__cell">
                             <button className="delete-button">X</button>
                           </div> */}
                  <div className="applications__cell text-center" style={{ cursor: "pointer" }}>
                    <span
                      className="shopper-badge table-row-background "
                      onClick={(e) => {
                        handleShopperDetailsClick(e, Card.userId.userId)
                      }}
                    >
                      {Card?.userId?.firstName} {Card?.userId?.lastName}
                    </span>
                  </div>
                  <div
                    className="applications__cell text-center"
                    style={{
                      background: "white",
                      textAlign: "center",
                      borderRadius: "5px",
                    }}
                  >
                    {new Date(Card?.selectedVisitDate).toLocaleDateString("en-GB")}
                  </div>
                  <div className="applications__cell text-center">{Card?.selectedVisitTime?.visitTimeInformation}</div>
                  <div className="applications__cell text-center">
                    {Card?.allocations?.[0]?.venueId?.venueName || 'N/A'}
                  </div>
                  <div className="applications__cell text-center">
                    {Card?.allocations?.[0]?.venueId?.venueId ? (
                      `${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.previousMonth?.[0]?.shopperFirstName} ${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.previousMonth?.[0]?.shopperLastName}` || '-'
                    ) : '-'}
                  </div>

                  <div className="applications__cell text-center">
                    {Card?.allocations?.[0]?.venueId?.venueId ? (
                      `${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.previousMonth?.[1]?.shopperFirstName} ${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.previousMonth?.[1]?.shopperLastName}` || '-'
                    ) : '-'}
                  </div>

                  <div className="applications__cell text-center">
                    {Card?.allocations?.[0]?.venueId?.venueId ? (
                      `${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.futureMonth?.[0]?.shopperFirstName} ${ShopperDetailsForTransBundle?.[Card?.allocations?.[0]?.allocationId]?.futureMonth?.[0]?.shopperLastName}` || '-'
                    ) : '-'}
                  </div>
                  <div className="applications__cell text-center">
                    <Button
                      className="action-button action-button--approve table-row-background"
                      onClick={() => handleBundlleShopperApprove(Card, "approved")}
                    >
                      Approve
                    </Button>
                    {/* <Button
                               className="action-button action-button--approve table-row-background"
                               onClick={() => { setOpenHoldReason(true) }}
                             >
                               Hold
                             </Button> */}
                  </div>
                </div>
              </>

            ))}
            {isActive1 && groupappliedAllocation?.map((Card: any, index: number) => (
              <>
                <Box className='border my-3 px-3  py-2' borderRadius='20px' >
                  <div style={{ borderBottom: '1px solid #a3a3a3' }} className="applications__cell applications__actions d-flex justify-content-between">
                    <Typography fontWeight='bold' variant="h6" onClick={(e) => {
                      handleShopperDetailsClick(e, Card.data[0].userId.userId)

                    }}
                    >
                      {Card.data[0].userId.firstName} {Card.data[0].userId.lastName}
                    </Typography>
                    <Box className='d-flex' gap={2}>
                      <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => handleUpdateBundleAppliedAllocation(appliedAllocation.bundleId, Card.userId, "approved")}
                      >
                        Approve
                      </Button>
                      <Tooltip
                        title={
                          Card?.data[0]?.isHold
                            ? Card?.data[0]?.holdReason || "NO Reason added"
                            : ""
                        }
                        arrow
                      >
                        <span>
                          <Button
                            disabled={Card?.data[0]?.isHold}
                            className="action-button action-button--approve table-row-background"
                            onClick={() => { setOpenHoldReason(true); setholdId(Card.userId) }}
                          >
                            Hold
                          </Button>
                        </span>
                      </Tooltip>
                      <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => handleRejectBundle(appliedAllocation.bundleId, Card.userId,)}
                      >
                        Reject
                      </Button>
                    </Box>
                  </div>
                  <div className="applications__header2 py-0 mt-2 table-row-background">
                    <div className="applications__header-cell text-center" style={{ width: '160px' }}>Date</div>
                    <div className="applications__header-cell text-center" style={{ width: '350px' }}>Time</div>
                    <div className="applications__header-cell">Site</div>
                    <div className="applications__header-cell text-center">Last Shopper</div>
                    <div className="applications__header-cell text-center">2nd Last Shopper</div>
                    <div className="applications__header-cell text-center">Future Shopper</div>
                  </div>

                  {Card.data.map((shopperApplied: any, index: number) => {
                    const key = shopperApplied?.appliedAllocationId;

                    const found = sendBundleData?.find((item: any) => item[key]);
                    return (
                      <div className="applications__row2 mt-2 gap-2" key={index}>
                        {/* <div
                                 className="applications__cell py-0 my-0"
                                 style={{
                                   background: "white",
                                   textAlign: "center",
                                   borderRadius: "5px",
                                 }}
                               >
                                 {new Date(shopperApplied.selectedVisitDate).toLocaleDateString("en-GB")}
                               </div> */}
                        <div className="applications__cell text-center py-0 my-0" >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker sx={{ width: "" }}
                              value={sendBundleData && dayjs(found?.[key]?.visitDate)}
                              format="DD/MM/YYYY"
                              onChange={(newValue) => {
                                const key = shopperApplied?.appliedAllocationId;

                                setSendBundleData((prev: any) =>
                                  prev.map((item: any) =>
                                    item[key]
                                      ? {
                                        ...item,
                                        [key]: {
                                          ...item[key],
                                          visitDate: newValue
                                            ? dayjs(newValue).format("YYYY-MM-DD")
                                            : null
                                        }
                                      }
                                      : item
                                  )
                                );
                              }}

                              minDate={dayjs(shopperApplied.selectedVisitDate).startOf("month")}
                              maxDate={dayjs(shopperApplied.selectedVisitDate).endOf("month")}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  sx: {
                                    background: 'white',
                                    borderRadius: '5px',
                                    width: '160px'
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                        {/* <div className="applications__cell py-0 my-0">{shopperApplied.selectedVisitTime.visitTimeInformation}</div> */}
                        <div className="applications__cell text-center py-0 my-0">
                          <Autocomplete
                            options={visitTimes}
                            getOptionLabel={(option: any) => option.visitTimeInformation}
                            value={
                              visitTimes.find((v: any) => v.visitTimeId == found?.[key]?.visitTime) || null

                            }
                            onChange={(event, newValue: any) => {
                              setSendBundleData((prev: any) =>
                                prev.map((item: any) =>
                                  item[key]
                                    ? {
                                      ...item,
                                      [key]: {
                                        ...item[key],
                                        visitTime: newValue ? newValue.visitTimeId : null,
                                      },
                                    }
                                    : item
                                )
                              );
                            }}

                            renderInput={(params) => <TextField {...params} label="Visit Time" size="small" fullWidth sx={{
                              minWidth: '300px',
                              "& .MuiInputBase-root": {
                                whiteSpace: "nowrap",
                                overflow: "visible",
                              },
                              "& .MuiAutocomplete-input": {
                                textOverflow: "unset",
                              },
                            }} />}
                          />
                        </div>
                        <div className="applications__cell py-0 my-0" style={{ width: "fit-content" }} >
                          {found?.[key]?.venueName}
                        </div>
                        {ShopperDetailsfornormalbundle?.[found?.[key]?.allocationId]?.previousMonth?.map((item: any, index: number) => {
                          if (index > 1) return;
                          return (
                            <div className="applications__cell text-center py-0 my-0"
                            // style={{cursor:'pointer'}}
                            //   onClick={(e) => {
                            //     handleOpenShopperPopup(e, index, item?.shopperId)
                            //   }}
                            >
                              {item?.shopperFirstName} {item?.shopperLastName}
                            </div>
                          )
                        })}
                        {ShopperDetailsfornormalbundle?.[found?.[key]?.allocationId]?.futureMonth?.map((item: any, index: number) => {
                          if (index > 0) return;
                          return (<div className="applications__cell text-center py-0 my-0"
                          // style={{cursor:'pointer'}}
                          //  onClick={(e) => {
                          //     handleOpenShopperPopup(e, index, item?.shopperId)
                          //   }}
                          >
                            {item?.shopperFirstName} {item?.shopperLastName}
                          </div>
                          )
                        })}
                      </div>

                    )
                  })}
                  <Dialog open={OpenHoldReason} onClose={() => { setOpenHoldReason(false) }}>
                    <DialogContent>
                      <TextField
                        required

                        className='p-0'
                        sx={{
                          width: '300px',
                          ".MuiOutlinedInput-input ": {
                            padding: '10px'
                          },
                          ".MuiInputLabel-root": {
                            top: '-6px'
                          }
                        }}
                        value={reasonforhold}
                        onChange={(e) => { setreasonforhold(e.target.value) }}
                        id="outlined-required"
                        label="Reason"
                      />
                      <Button sx={{ color: 'white' }} className="d-block mt-3 mx-auto action-button action-button--approve table-row-background"
                        onClick={() => { (reasonforhold.length > 0) ? handleHoldBundleAppliedAllocation(appliedAllocation.bundleId, holdId) : alert("Reason is requierd") }}>
                        Submit
                      </Button>
                    </DialogContent>
                  </Dialog>
                </Box>
              </>
            ))}
          </div>
        </DialogContent >
      </Dialog>

      <Dialog
        open={openIssueDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            pb: 1,
          }}
        >
          <Warning sx={{ color: "error.main" }} />
          <Typography variant="h6" component="span">
            Allocation Issues
          </Typography>
          <IconButton onClick={handleCloseDialog} sx={{ ml: "auto" }} size="small">
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {issueList?.warnings?.length > 0 ? (
            <List dense>
              {issueList?.warnings.map((issue: any, index: number) => (
                <ListItem key={index} sx={{ px: 0 }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Error sx={{ color: "error.main", fontSize: 20 }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={issue}
                    primaryTypographyProps={{
                      variant: "body2",
                      color: "text.primary",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                py: 3,
              }}
            >
              <Typography variant="body1" color="success.main">
                ✅ No issues found with the current allocation criteria.
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={handleCloseDialog} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={(brief && !brief?.isNewStructureResponse)} maxWidth="lg" fullWidth>
        <DialogContent>
          {brief?.data ? (
            <>
              <Box className='d-flex align-items-center justify-content-between mb-2'>
                <Typography variant="h5" className="fw-bold">{brief?.data[0]?.title}</Typography>
                <IconButton
                  className="ms-auto d-block"
                  onClick={() => {
                    setBrief(null)
                  }}
                >
                  <CancelOutlined className="fd-2" />
                </IconButton>
              </Box>
              <Box
                overflow="auto"
                className='venue-description'
                dangerouslySetInnerHTML={{
                  __html:
                    brief?.data?.[0]?.description,
                }}
              />
              <Box className='d-flex align-items-center justify-content-center'>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className="table-row-background"
                sx={{padding:'7px 20px'}}
                onClick={() => { setBrief(null) }}
              >
                Done
              </Button>
              </Box>
            </>
          ) : (
            <Typography variant="subtitle1">No Data Found</Typography>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={brief && brief?.isNewStructureResponse} PaperProps={{
        sx: {
          height: '90vh',
        },
      }} className="full-dilaog d-flex flex-column" maxWidth="xl" fullWidth>
        <DialogContent className="p-0" sx={{ flex: 1 }}>
          {brief && brief?.isNewStructureResponse && <ReadBrief key={brief} handleClose={() => setBrief(null)} newBrief={brief?.data} title={brief?.mainTitle} />}
        </DialogContent>
      </Dialog>
    </div >
  )
}